<template>
  <div class="article articleSymptom">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <!-- ===================== man only start ====================== -->
      <div class="auditInfo" v-if="app_type == 'man'">
        <p class="auditName">
          {{ form.contentName }}
        </p>
        <p class="auditJob">
          {{ actionType == 8 ? "疾病ID:" : "症状ID:" }}{{ form.contentId }}
        </p>
      </div>
      <!-- ===================== man only end ====================== -->

      <div class="c-title-wrap">
        <p class="c-title">基本内容</p>
      </div>

      <div
        class="content-item flex align-items-center"
        v-if="app_type == 'user'"
      >
        <p>
          <span class="red">*</span
          >{{ actionType == 8 ? "疾病名称" : "症状名称" }}
        </p>
        <el-input
          id="selectRole"
          class="article_tit"
          maxlength="50"
          show-word-limit
          placeholder="请输入名称"
          v-model="form.contentName"
        ></el-input>
      </div>
      <div class="alias">
        <contentAlias-Names
          :aliasName.sync="form.contentAliasNames"
        ></contentAlias-Names>
      </div>
      <div class="content-item flex" v-if="actionType == 8">
        <p><span class="red">*</span>是否传染病</p>
        <el-radio-group
          v-model="infectiousMark"
          class="flex align-items-center"
        >
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </div>
      <!-- 症状部位 -->
      <div
        class="flex align-items-center department-item"
        v-if="actionType == 9"
      >
        <p><span class="red">*</span>症状部位</p>
        <el-select
          multiple
          v-model="symptomsPartsValue"
          placeholder="请选择症状部位"
          @change="bodyPart"
        >
          <el-option
            v-for="(item, index) in symptomsParts"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="flex align-items-center department-item one">
        <p>建议科室</p>
        <el-cascader
          placeholder="请选择科室"
          :value="selectedDeparttId"
          :options="departmentList"
          :props="departmentProps"
          @change="changeDepartment"
          :show-all-levels="false"
          ref="cascader"
        ></el-cascader>
      </div>
      <!-- 关联疾病 -->
      <contentLabel-cp
        :data="form.contentRelations"
        @changeDiseaseLabels="changeDiseaseLabels"
        :is-show-disease="isShowDisease"
        :actionType="actionType"
        :functionIds="{ queryContents: 'health_cmp_queryContents' }"
      />

      <div
        class="content-item flex"
        style="position: relative"
        v-for="(item, index) in paragraphList"
        :key="index"
      >
        <p><span class="red">*</span>{{ item.desc }}</p>
        <!--        <editor-cp-->
        <!--          :content="item.content || ''"-->
        <!--          :index="index"-->
        <!--          @editorReady="editorReady"-->
        <!--          :ref="'editor' + index"-->
        <!--          @blurEditorEvent="blurEditorEvent"-->
        <!--        ></editor-cp>-->
        <c-editor
          :content="item.content || ''"
          :index="index"
          @editorReady="editorReady"
          :ref="'editor' + index"
          @blurEditorEvent="blurEditorEvent"
        >
        </c-editor>
      </div>
      <div v-if="contentLabels && contentLabels.length && app_type == 'man'">
        <div>
          <div
            class="content-item flex articleLabel"
            v-for="(item, index) in contentLabels"
            :key="index"
          >
            <p>{{ item.name }}</p>
            <div
              class="tab-list"
              v-if="item.contentLabels && item.contentLabels.length"
            >
              <span
                class="check-box"
                :class="{ tabs: label.isChecked }"
                v-for="(label, labelIndex) in item.contentLabels"
                :key="labelIndex"
                @click="checkArticleLabel(label)"
                >{{ label.name }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="content-item flex align-items-center">
        <p><span class="red">*</span>关键词</p>
        <!-- <el-select v-model="keywordTag" multiple-limit="50" multiple filterable allow-create default-first-option placeholder="请选择" size="mini" style="width: 240px" class="selectBus">
          <el-option v-for="item in keywordOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <div class="keyword-list">
          <el-tag
            size="mini"
            :key="item"
            v-for="item in keywordInfos"
            closable
            :disable-transitions="false"
            style="margin-left: 10px"
            @close="closeTag(item)"
            >{{ item }}
          </el-tag>
          <el-input
            class="input-keyword"
            v-model="inputValue"
            ref="saveTagInput"
            size="mini"
            maxlength="50"
            @keyup.enter.native="getKeyword"
            placeholder="输入关键词后，回车确定；关键词可输入多个"
          ></el-input>
        </div>
      </div>
      <div
        class="writeDoc content-item flex align-items-center"
        v-if="actionType == 9"
      >
        <p>编写医生</p>
        <el-select
          v-model="writeDoctor"
          filterable
          placeholder="请选择"
          size="mini"
          class="selectBus"
          remote
          :remote-method="write_remoteMethod"
          :loading="write_doctor_loading"
          @change="writeChange"
          clearable
        >
          <el-option
            v-for="(item, index) in writeOptions"
            :key="index"
            :label="
              item.docName +
              '  ' +
              item.titleName +
              '  ' +
              item.hospitalGradeName +
              '  ' +
              item.hospitalName +
              '  ' +
              item.departName
            "
            :value="item.docId"
          >
          </el-option>
        </el-select>
      </div>
      <div
        class="writeDoc content-item flex align-items-center"
        v-if="app_type == 'man'"
      >
        <div
          class="flex align-items-center"
          v-if="actionType == 8 || actionType == 9"
        >
          <p>编审医生</p>
          <el-select
            v-model="doctor"
            filterable
            placeholder="请选择"
            size="mini"
            class="selectBus"
            remote
            :remote-method="doctor_remoteMethod"
            :loading="search_doctor_loading"
            @change="writeChange"
            clearable
          >
            <el-option
              v-for="(item, index) in doctorOptions"
              :key="index"
              :label="
                item.docName +
                '  ' +
                item.titleName +
                '  ' +
                item.hospitalGradeName +
                '  ' +
                item.hospitalName +
                '  ' +
                item.departName
              "
              :value="item.docId"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="finish-buttons" v-if="app_type == 'user'">
      <el-button @click="saveOrUpdateDiseaseInfo(0, 'preview')"
        ><span>预览</span>
      </el-button>
      <el-button
        @click="saveOrUpdateDiseaseInfo(1, 'draft')"
        v-if="auditInfoShow !== 3"
        ><span>保存</span>
      </el-button>
      <el-button type="primary" @click="saveOrUpdateDiseaseInfo(2, 'submit')"
        ><span>提交</span>
      </el-button>
    </div>
    <div class="finish-btns" v-else>
      <el-button
        type="primary"
        @click="manOrUpdateDiseaseInfo(2, 'through')"
        v-if="auditInfoShow == 2"
        ><span>通过</span></el-button
      >
      <el-button @click="rejectClick" v-if="auditInfoShow == 2">
        <span>驳回</span>
      </el-button>
      <el-button
        @click="manOrUpdateDiseaseInfo(1, 'save')"
        v-if="auditInfoShow == 2 ? false : auditInfoShow == 3 ? false : true"
      >
        <span>保存</span>
      </el-button>
      <el-button
        @click="manOrUpdateDiseaseInfo(2, 'manSubmit')"
        v-if="auditInfoShow !== 2"
      >
        <span>提交</span>
      </el-button>
      <el-button @click="manOrUpdateDiseaseInfo(0, 'manPreview')">
        <span>预览</span>
      </el-button>
    </div>
    <modal
      :isShow.sync="dialogPreVisible"
      :title="dialogTitles"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
    >
      <div class="content">
        <p class="before-content-color title">
          <span class="before-icon"></span> 移动端链接
        </p>
        <div class="image">
          <div class="flexs middle-a dialog-btns middle-a">
            <el-input
              class="dialog-input"
              v-model="mUrl"
              placeholder="请输入移动端链接"
            ></el-input>
            <el-button class="color" type="text" size="small"
              ><a :href="mUrl" target="_blank">打开</a></el-button
            >
            <el-button type="text" size="small" @click="copyUrl(mUrl)"
              >复制
            </el-button>
          </div>
          <p class="dislog-sub-title">
            *预览页面不可用于商业用途，链接有效时间5分钟，超时过期请重新打开预览弹窗！
          </p>
          <div class="qrCode">
            <img :src="qrCode" alt="二维码图片" />
          </div>
          <div class="img-des">扫描二维码手机查看</div>
        </div>
      </div>
    </modal>
    <modal
      v-if="app_type == 'man'"
      :isShow.sync="rejectForm.rejectlineDialog"
      title="驳回"
      :isShowBtn="rejectForm.isShowBtn"
      :btnText="rejectForm.ordinaryBtnText"
      @clickHandler="rejectClickHandler"
    >
      <el-form :model="rejectForm" label-width="100px">
        <span class="red">*</span>
        <el-form-item label="驳回理由" class="freezeDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入驳回理由，不超过200字"
            v-model="rejectForm.rejectReasons"
            maxlength="200"
            show-word-limit
            class="freezeInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
    <modal
      :isShow.sync="deleteForm.deleteDialog"
      title="删除"
      :isShowBtn="deleteForm.isShowBtn"
      :btnText="deleteForm.btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">需要删除所有疾病百科信息吗？</div>
    </modal>

    <modal
      :isShow.sync="reset_Diseases"
      title="更换疾病名称"
      :btnText="DialogBtn"
      :isShowBtn="ShowBtn"
      :width="Width"
      @clickHandler="repealclickHandler"
    >
      <div class="dialogVal">更改疾病将清空已填疾病的所有内容，是否继续?</div>
    </modal>
  </div>
</template>
<script>
import contentAliasNames from "@/components/input/contentAliasNames";
import breadCrumb from "@/components/breadCrumb";
import modal from "@/components/modal";
import CEditor from "@/components/editor/CEditor";
import contentLabelCp from "./tag/contentLabelCp";
import {
  searchDiseaseInfoByParam,
  getContentParagraphDictionary,
  healthCmpQueryBodyParts,
} from "@/api/user.js";

import {
  listTenantContentLabels,
  newDiseaseSymptoms,
  getDoctorInformation,
  submittedByWriter,
  getDiseaseSymptomsDraftDetails,
  operationSubmission,
  auditDiseaseSymptoms,
  rejectedDiseaseSymptoms,
  manToUpdate,
  queryDepartmentAssociation,
} from "@/api/symptomaticDisease";
import QRCode from "qrcode";
import { mapState } from "vuex";
import utils from "../utils";

var app_type = process.env.VUE_APP_TYPE;
const baseUrl = process.env.VUE_APP_BASEURL;
import { chain } from "lodash";

export default {
  data() {
    return {
      // 失去焦点编辑器保存提示成功时间，定时清除提示
      tipTimeout: null,
      //疾病搜索
      loading: false,
      inputDiseaseInfo: "",
      inputDiseaseInfoId: "",
      selectDiseaseInfoIdDisabled: false,
      diseaseInfoOptions: [],
      //结束疾病搜索
      reset_Diseases: false, // 修改关联疾病名称
      DialogBtn: [],
      ShowBtn: [],
      Width: "400px",
      //科室
      departmentList: [],
      departmentProps: {
        multiple: true,
        checkStrictly: true,
        value: "departId",
        label: "departName",
        children: "departmentDTOList",
      },
      selectedDeparttId: [],
      oldSelectedDeparttId: [],
      //结束科室
      paragraphList: [], // 段落
      editorList: {},
      //结束编辑器相关
      //疾病特殊标签
      contentLabels: [],
      //关键词
      keywordInfos: [],
      // keywordTag: [],
      // 编审医生
      search_doctor_loading: false,
      doctorOptions: [],
      // 编写医生
      write_doctor_loading: false,
      writeOptions: [],
      doctor: "",
      writeDoctor: "",
      //结束关键词
      originalTips: false,
      actionType: "",
      user_identity: 0, // 身份信息
      app_type,
      baseUrl,
      infectiousMark: "", // 是否传染病
      // 疾病百科信息集合
      form: {
        contentAliasNames: [],
        contentId: undefined, // 内容基本信息id
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 内容名称
        englishName: undefined, // 英文名
        pinyinFirstLetter: undefined, // 拼音首字母
        diseaseInfo: {}, // 是否传染病
        contentType: undefined, // 疾病类型 默认8疾病百科 9疾病百科
        contentRelations: [], // 关联的其他内容 仅需要id和type
        contentStatus: null, // 内容状态 1 上线 2下线
        auditInfo: {}, // 审核信息
        contentLabels: [], // 标签信息
        contentParagraphs: [], // 段落信息
        contentUsers: [], // 内容关联的用户
        keywordInfos: [], // 内容关键词
        bodyParts: [], // 身体部位
        doctorInfos: [], // 关联的医生
        // editreviewType:null, // 编审类型 1 平台医生 2 黄页医生
        contentAuditStatus: 1, // 内容审核状态1草稿、2待审核、3审核通过、4驳回
        departments: [], // 科室信息
      },
      dialogTitles: "预览",
      btnText: [],
      dialogWidth: "722px",
      isShowBtn: [false, false],
      dialogPreVisible: false,
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      // 删除弹框
      deleteForm: {
        deleteDialog: false,
        btnText: ["不删除", "删除"],
        isShowBtn: [true, true, false],
      },
      isShowDisease: false,
      inputVisible: false,
      inputValue: "",
      symptomsParts: [], // 部位
      symptomsPartsValue: [], // 部位值
      auditInfoShow: "",
      contentStatus: "",
      arrPartsList: [],
    };
  },
  components: {
    contentAliasNames,
    modal,
    breadCrumb,
    contentLabelCp,
    CEditor,
  },
  created() {
    //获取标签
    if (app_type == "man") {
      this.listTenantContentLabels();
    }
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
      this.getDiseaseInfoDraftDetail();
    }
    if (this.$route.query.articleType) {
      this.actionType = this.$route.query.articleType;
    }
    //获取科室
    this.queryDepartments();
  },
  computed: {
    // 计算属性的 getter
    ...mapState(["isShowOriginalAuthor"]),
  },
  async mounted() {
    Array.prototype.diff = function (a) {
      return this.filter(function (i) {
        return a.indexOf(i) < 0;
      });
    };
    let that = this;
    //改写el函数
    this.$refs.cascader.computePresentTags = function () {
      const { isDisabled, leafOnly, showAllLevels, separator, collapseTags } =
        this;
      const checkedNodes = this.getCheckedNodes(leafOnly);
      const tags = [];
      const genTag = (node) => ({
        node,
        key: node.uid,
        text: node.getText(showAllLevels, separator),
        hitState: false,
        closable: !isDisabled && !node.isDisabled,
      });
      if (checkedNodes.length) {
        if (collapseTags) {
          tags.push({
            key: -1,
            text: `+ ${checkedNodes.length}`,
            closable: false,
          });
        } else {
          that.selectedDeparttId.forEach((item, index) => {
            const nodeItem = checkedNodes.filter((nodeItem) => {
              //匹配菜单层级
              if (
                item.length == nodeItem.level &&
                nodeItem.value == item[item.length - 1]
              )
                return nodeItem;
            });
            tags.push(genTag(nodeItem[0]));
          });
        }
      }
      this.checkedNodes = checkedNodes;
      this.presentTags = tags;
    };
    this.$refs.cascader.computePresentTags.call(this.$refs.cascader);
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
    this.init();
    await this.getSymptomsParts();

    //获取段落
    this.getContentParagraphDictionary();

    // 如果是编辑文章
    if (this.$route.query.id) {
    }

    // 点击空白地方，文章内容存到缓存里面，当刷新页面的时候能够回显
    var _this = this;
    var flag = true;
    var isjqTri = false;
    var selectRoleSetTimeout;
    $("#selectRole")
      .on("compositionstart", function () {
        flag = false;
      })
      .on("compositionend", function () {
        flag = true;
      })
      .on("input", function (e) {
        clearTimeout(selectRoleSetTimeout);
        if (!this.loading)
          selectRoleSetTimeout = setTimeout(function () {
            if (flag && !isjqTri) {
              isjqTri = true;
            } else {
              isjqTri = false;
            }
          }, 100);
      });
  },
  activated: function () {
    // this.articleStatus = this.$route.query.articleStatus
    // this.init()
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
    // 移除段落缓存
    sessionStorage.removeItem("cache_articles");
  },
  methods: {
    cancel: function () {
      if (app_type == "user" && this.$route.query.id) {
        this.$router.push(`/manageBK`);
      }
      if (app_type == "man") {
        if (this.actionType == 8) {
          this.$router.push(`/wikiManage/wiki`);
        } else if (this.actionType == 9) {
          this.$router.push(`/wikiManage/symptom`);
        }
        this.hopStorage();
      }
    },
    // 身体部位需要的得value和label的值
    bodyPart(val) {
      if (val.length > 5) {
        this.$message.error("最多选择5个部位");
      }
      this.symptomsPartsValue = val.filter((item, index) => {
        return index < 5;
      });
    },
    blurEditorEvent(editor, index) {
      // 编辑文章不做临时保存操作
      /*if(this.form.contentId){
          return;
        }*/
      this.paragraphList[index].content = editor.getContent() || "";
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // let ParentElement = $(editor.editorContainer).find(".tox-toolbar__group").eq(0)
      // let subelement = ParentElement.find(".successfully")
      // // 只创建一次
      // if (subelement.length == 0) {
      //   $(editor.editorContainer).find(".tox-toolbar__group").eq(0).append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function () {
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove()
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      this.form.contentParagraphs[index].paragraphContent =
        editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },
    closeTag(item) {
      this.keywordInfos.splice(this.keywordInfos.indexOf(item), 1);
    },
    getKeyword() {
      let isPush = this.keywordInfos.some((item) => item == this.inputValue);
      if (!isPush) {
        this.keywordInfos.push(this.inputValue);
        if (this.keywordInfos.length > 20) {
          this.keywordInfos.pop();
          this.inputValue = "";
          this.$message.error("最多20个关键字");
          return false;
        }
      }
      this.inputValue = "";
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
    },
    //初始化获取文章标签和疾病标签
    init() {
      this.user_identity = sessionStorage.getItem("user_identity");
    },

    // 编审医生
    doctor_remoteMethod(query) {
      this.doctorList(query, "doctorOptions", "search_doctor_loading");
    },
    // 编写医生
    write_remoteMethod(query) {
      this.doctorList(query, "writeOptions", "write_doctor_loading");
    },
    writeChange() {
      if (this.writeDoctor == "") {
        this.writeOptions = [];
      }
      if (this.doctor == "") {
        this.doctorOptions = [];
      }
    },
    doctorList(query, str, loadingStr) {
      if (query !== "") {
        this[loadingStr] = true;
        getDoctorInformation({
          tenantId: this.$commonJs.getTenantId(),
          doctorName: query,
        })
          .then((res) => {
            this[str] = res;
            this[loadingStr] = false;
          })
          .catch((err) => {
            this[str] = [];
            this[loadingStr] = false;
          });
      } else {
        this[str] = [];
      }
    },
    //获取文章详情
    getDiseaseInfoDraftDetail(CB) {
      getDiseaseSymptomsDraftDetails({
        contentId: this.form.contentId,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          this.form.contentStatus = res.contentStatus;
          this.form.contentAuditStatus = res.contentAuditStatus;
          // 检查缓存更新时间和最新更新时间确定是否删除缓存
          var cacheArticle = this.$commonJs.getArticleDataFromCache(
            res.contentId
          );
          if (cacheArticle) {
            try {
              var cacheUpdate = new Date(
                cacheArticle.updateTime.replace(/-/g, "/")
              );
              var lastUpdate = new Date(res.updateTime.replace(/-/g, "/"));
              if (lastUpdate.getTime() > cacheUpdate.getTime()) {
                this.$commonJs.removeCacheArticleData(res.contentId);
              }
            } catch (error) {
              console.log(error);
            }
          }
          this.displayInfo(res);
          CB && CB();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 是否跟换名称
    repealclickHandler(val) {
      if (val === "one") {
        this.reset_Diseases = false;
        this.getDiseaseInfoDraftDetail();
      } else if (val === "two") {
        this.reset_Diseases = false;
      }
    },

    //反显信息
    displayInfo(res) {
      if (res.departments) {
        res.departments.map((item) => {
          if (item.departLevel == 1) {
            this.selectedDeparttId.push([item.departId]);
          } else {
            this.selectedDeparttId.push([item.parentId, item.departId]);
          }
        });
      }
      if (res.contentStatus) {
        this.contentStatus = res.contentStatus;
      }
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      //反显疾病名称
      if (res.contentName) {
        this.form.contentName = res.contentName;
        this.inputDiseaseInfo = res.contentName;
      }

      //反显别名
      if (!res.contentAliasNames) {
        this.form.contentAliasNames = [];
      } else {
        this.form.contentAliasNames = res.contentAliasNames;
      }
      if (res.diseaseInfo) {
        this.infectiousMark = res.diseaseInfo.infectiousMark;
      }
      // 返显部位
      if (res.bodyParts) {
        res.bodyParts.map((item) => {
          if (item.id) {
            this.symptomsPartsValue.push(item.id);
          }
        });
      }
      //反显关联疾病
      this.form.contentRelations = res.contentRelations || [];
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      if (!cache_article) {
        var isFirstAdd = this.paragraphList.length == 0;
        res.contentParagraphs &&
          res.contentParagraphs.map((item, index) => {
            if (isFirstAdd) {
              this.paragraphList.push({
                code: item.paragraphCode,
                desc: item.paragraphName,
                type: item.paragraphType,
                content: item.paragraphContent || "",
              });
            } else {
              for (var i = 0; i < this.paragraphList.length; i++) {
                if (this.paragraphList[i].code == item.paragraphCode) {
                  this.paragraphList[i].content == item.paragraphContent || "";
                  break;
                }
              }
            }
            try {
              var isEditorInited = setInterval(() => {
                var edd = this.editorList["editor" + index];
                if (edd) {
                  clearInterval(isEditorInited);
                  edd.setContent(item.paragraphContent || "");
                }
              }, 100);
            } catch (error) {
              console.log(error);
            }
          });
      }
      // 回显上次保存的标签
      this.form.contentLabels = res.contentLabels || [];
      if (app_type == "man") {
        this.showSelectedLabels();
      }
      //反显关键字
      this.keywordInfos = [];
      res.keywordInfos &&
        res.keywordInfos.map((item, index) => {
          this.keywordInfos.push(item.keyword);
        });
      this.writeOptions = [];
      this.doctorOptions = [];
      if (res.doctorInfos) {
        res.doctorInfos.map((item) => {
          if (item.roleType == 1) {
            this.writeOptions.push(item);
            this.writeDoctor = item.docId;
          }
        });
      }
      // 编审 编写医生
      if (app_type == "man") {
        if (res.doctorInfos) {
          res.doctorInfos.map((item) => {
            if (item.roleType == 2) {
              this.doctorOptions.push(item);
              this.doctor = item.docId;
            }
          });
        }
      }
    },
    // 回显标签
    showSelectedLabels() {
      if (!this.form.contentLabels || !this.form.contentLabels.length) return;
      this.listTenantContentLabels()
        .then(() => {
          for (var i = 0; i < this.contentLabels.length; i++) {
            var group = this.contentLabels[i];
            for (var j = 0; j < group.contentLabels.length; j++) {
              var label1 = group.contentLabels[j];
              for (var k = 0; k < this.form.contentLabels.length; k++) {
                var seletedLabel = this.form.contentLabels[k];
                if (label1.id == seletedLabel.id) {
                  this.$set(label1, "isChecked", true);
                  break;
                }
              }
            }
          }
        })
        .catch((err) => {
          console.error("回显标签 showSelectedLabels error", err);
        });
    },
    generateDiseaseId() {
      return (
        "diseaseInfoId_" +
        new Date().getTime() +
        Math.floor(Math.random() * 1000)
      );
    },
    changeDiseaseInfo(val) {
      //选中关键词
      for (let i = 0; i < this.diseaseInfoOptions.length; i++) {
        var di = this.diseaseInfoOptions[i];
        if (di.contentId == val) {
          //反显信息 a new notExist item in db. select not exist item should not clear other infos.
          if (
            typeof di.contentId == "string" &&
            di.contentId.indexOf("diseaseInfoId_") == 0
          ) {
            //反显疾病名称
            this.form.contentName = di.contentName;
            this.diseaseInfoOptions = [
              {
                contentName: di.contentName,
                contentId: di.contentId,
              },
            ];
            this.selectDiseaseInfoId = di.contentId;
          } else {
            // switch an existedItem
            this.displayInfo(di);
          }
        }
      }
    },
    clearDiseaseInfo() {
      this.diseaseInfoOptions = [];
      this.deleteForm.deleteDialog = true;
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteForm.deleteDialog = false;
      } else if (val === "two") {
        // 清空contentID
        this.form.contentId = undefined;
        //疾病名称
        this.form.contentName = "";
        this.diseaseInfoOptions = [];
        this.selectDiseaseInfoId = "";
        //别名
        this.form.aliasName = "";
        //传染病
        if (this.actionType == 8) {
          this.infectiousMark = "";
        }
        //科室
        this.selectedDeparttId = [];
        //关联疾病
        this.form.contentRelations = [];
        //段落
        this.paragraphList.map((item, index) => {
          item.content = "";
        });
        //业务标签
        this.contentLabels = [];
        //关键字
        this.keywordInfos = [];
        this.deleteForm.deleteDialog = false;
      }
    },
    // 获取症状部位
    async getSymptomsParts() {
      await healthCmpQueryBodyParts({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.symptomsParts = res.data;
      });
    },
    //获取科室信息
    queryDepartments() {
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.form.contentId || "",
      };
      queryDepartmentAssociation(params)
        .then((res) => {
          this.departmentList = res || [];
        })
        .catch((err) => {
          this.departmentList = [];
        });
    },
    changeDepartment(val) {
      // 回显赋值
      this.newList = [...this.selectedDeparttId];
      let _val = val.map((item) => {
        return item.toString();
      });
      let _newList = this.newList.map((item) => {
        return item.toString();
      });
      // 删除
      if (this.newList.length > val.length) {
        let remove = _newList.diff(_val);
        this.newList.splice(_newList.indexOf(remove[0]), 1);
      } else {
        // 增加 查找新增项
        let add = _val.diff(_newList);
        this.newList.push(val[_val.indexOf(add[0])]);
      }
      if (this.newList.length > 5) {
        this.$message.error("最多选择5个科室");
        this.newList.pop();
      }
      this.selectedDeparttId = [...this.newList];
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    //获取段落信息
    getContentParagraphDictionary() {
      getContentParagraphDictionary({
        type: this.actionType == 8 ? 1 : 3, // 1疾病百科，3症状百科
      })
        .then((res) => {
          this.paragraphList = res || [];
        })
        .catch((err) => {});
    },
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    listTenantContentLabels() {
      return new Promise((resovle, reject) => {
        if (this.contentLabels.length == 0) {
          listTenantContentLabels({
            tenantId: this.$commonJs.getTenantId(),
          })
            .then((res) => {
              this.contentLabels = res.data || [];
              resovle(this.contentLabels);
            })
            .catch((err) => {
              reject(err);
            });
        } else {
          resovle(this.contentLabels);
        }
      });
    },
    //选中文章标签
    checkArticleLabel(label) {
      this.$set(label, "isChecked", !label.isChecked);

      let arr = this.form.contentLabels || [];
      //判断是否存在当前项，如果存在则取消选中并从数据中删除
      if (!label.isChecked) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == label.id) {
            this.form.contentLabels.splice(i, 1);
            return false;
          }
        }
      }
      let obj = {
        labelGroupId: label.labelGroupId,
        id: label.id,
        name: label.name,
      };
      this.form.contentLabels.push(obj);
    },
    /**
     * @desc 由于某些特殊字段，无法使用vue v-model绑定操作，需要js手工赋值，故在保存，预览，提交，发布，审核文章前初始化一些表单的数据,比如上传图片，视频等信息
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     */
    initFormBeforeAddOrUpdate(val, opt_type) {
      //根据按钮状态修改articleStatus值 bugfix: 预览接口报异常 预览时 文章状态和草稿状态一致
      this.form.contentName = this.form.contentName.trim();
      //科室信息
      this.form.departments = [];
      this.selectedDeparttId.map((item) => {
        if (item.length == 1) {
          this.form.departments.push({
            departId: item[0],
          });
        } else {
          this.form.departments.push({
            departId: item[1],
          });
        }
      });
      this.form.bodyParts = [];
      this.symptomsParts.map((item) => {
        this.symptomsPartsValue.map((id) => {
          if (item.id == id) {
            this.form.bodyParts.push(item);
          }
        });
      });
      //获取段落内容
      this.form.contentParagraphs = [];
      this.paragraphList.map((item, index) => {
        this.form.contentParagraphs.push({
          paragraphCode: item.code,
          paragraphName: item.desc,
          paragraphType: item.type,
          paragraphContent:
            this.editorList["editor" + index].getContent() || "",
        });
      });
      //关键词
      if (this.keywordInfos.length) {
        let arr = [];
        this.keywordInfos.map((item) => {
          arr.push({
            keyword: item,
            keywordType: "1",
          });
        });
        this.form.keywordInfos = arr;
      } else {
        this.form.keywordInfos = [];
      }
      this.form.doctorInfos = [];
      // 编写医生
      this.writeOptions.map((item) => {
        if (this.writeDoctor == item.docId) {
          item.roleType = 1;
          this.form.doctorInfos.push(item);
        }
      });
      // 编审医生
      if (app_type == "man") {
        // 编审医生
        this.doctorOptions.map((item) => {
          if (this.doctor == item.docId) {
            item.roleType = 2;
            this.form.doctorInfos.push(item);
          }
        });
      }
      if (app_type == "man") {
        this.form.contentStatus = this.contentStatus;
      }
      if (app_type == "user") {
        this.form.auditInfo = {
          auditStatus: 1,
        };
      }
      // 传染病
      this.form.diseaseInfo = {
        infectiousMark: this.infectiousMark,
      };
      // 疾病和症状参数
      // contentType 8: 疾病百科 9: 症状百科
      this.form.contentType = Number(this.actionType);
    },
    /**
     * @desc 保存，预览，提交，发布，审核文章的检查函数
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     * @return true: 表单检查通过， false: ....
     */

    checkBeforeAddOrUpdate(val, opt_type) {
      // 保存文章状态不变
      if (!this.form.contentName || this.form.contentName.trim() == "") {
        this.$message.error(
          Number(this.actionType) == 8 ? "疾病名称不能为空" : "症状名称不能为空"
        );
        return false;
      }
      //保存草稿，只校验标题
      if (
        (val == 1 || val == 0) &&
        (this.form.contentAuditStatus == 1 || !this.form.contentAuditStatus)
      ) {
        return true;
      }

      if (Number(this.actionType) == 8 && this.infectiousMark === "") {
        this.$message.error("请确认是否为传染病");
        return false;
      }
      if (Number(this.actionType) == 9) {
        if (this.symptomsPartsValue == "") {
          this.$message.error("症状部位不能为空");
          return false;
        }
      }
      let isParagraphsPass = true;
      let paragraphsText = [];
      isParagraphsPass = this.form.contentParagraphs.some((item) => {
        paragraphsText.push(item.paragraphName);
        return item.paragraphContent != "";
      });
      if (!this.form.keywordInfos.length) {
        this.$message.error("关键词不能为空");
        return false;
      }
      if (!isParagraphsPass) {
        this.$message.error(paragraphsText.join(",") + "至少填写一项");
        return false;
      }

      return true;
    },
    // 保存
    saveOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        return;
      }
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      let params = this.$commonJs.deepClone(this.form);
      newDiseaseSymptoms(params)
        .then((res) => {
          this.form.contentId = res.contentId;
          // 预览
          if (type == "preview") {
            this.articlePreview(res);
          }
          //保存草稿
          if (type == "draft") {
            this.$message.success("保存成功");
          } else if (type == "submit") {
            // auditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
            params.auditInfo = { auditStatus: 2 };
            submittedByWriter({
              contentId: res.contentId,
              tenantId: this.$commonJs.getTenantId(),
            })
              .then((res) => {
                if (res) {
                  this.$router.push(`/manageBK`);
                }
                this.$message.success("提交成功");
              })
              .catch((err) => {
                this.$message.error(err.msg + "发布失败");
              });
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || "操作失败！");
        });
    },

    // man-审核
    manOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        return;
      }
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      let params = this.$commonJs.deepClone(this.form);
      manToUpdate(params).then((res) => {
        let contentIds = {
          contentId: res.contentId,
          tenantId: this.$commonJs.getTenantId(),
        };
        this.form.contentId = res.contentId;
        if (type == "manPreview") {
          this.articlePreview(res);
        }
        // 保存
        if (type == "save") {
          this.$message.success("保存成功");
        } else if (type == "through") {
          params.auditInfo = { auditStatus: 3 };
          // 审核
          auditDiseaseSymptoms(contentIds)
            .then((res) => {
              this.$message.success("审核通过");
              this.actionType == 8
                ? this.$router.push(`/wikiManage/wiki`)
                : this.$router.push(`/wikiManage/symptom`);
              this.hopStorage();
            })
            .catch((err) => {
              this.$message.error(err.msg || "审核失败");
            });
        } else if (type == "manSubmit") {
          params.auditInfo = { auditStatus: 2 };
          operationSubmission(contentIds)
            .then((res) => {
              if (res) {
                this.actionType == 8
                  ? this.$router.push(`/wikiManage/wiki`)
                  : this.$router.push(`/wikiManage/symptom`);
                this.hopStorage();
              }
              this.$message.success("提交成功");
            })
            .catch((err) => {
              this.$message.error(err.msg + "发布失败");
            });
        }
      });
    },
    hopStorage() {
      // 跳转列表页存储状态
      if (this.actionType == 8) {
        sessionStorage.setItem("disease", 1);
      } else if (this.actionType == 9) {
        sessionStorage.setItem("symptoms", 1);
      }
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      if (val.contentType == 8) {
        this.jumpUrl(val.contentType, "disease/", "preview/", val.contentId);
      }
      if (val.contentType == 9) {
        this.jumpUrl(val.contentType, "symptom/", "preview/", val.contentId);
      }
    },
    jumpUrl(type, url, urlPre, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.jd.com/wiki/"; // 疾病症状预发地址
      let diseaseOnline = "https://cont.healthjd.com/wiki/disease"; // 线上疾病
      let symptomOnline = "https://cont.healthjd.com/wiki/symptom/"; // 线上症状
      let newUrl;
      if (this.baseUrl == urlAddress) {
        // 预发
        newUrl = previewUrl1 + url + urlPre + urlId;
      } else {
        if (type == 8) {
          // 线上疾病
          newUrl = diseaseOnline + urlPre + urlId;
        } else {
          newUrl = symptomOnline + urlPre + urlId;
        }
      }
      this.mUrl = newUrl;
      this.getQRCode(newUrl);
    },
    //生成二维码
    getQRCode(val) {
      var opts = {
        errorCorrectionLevel: "H",
        type: "image/jpeg",
        rendererOpts: {
          quality: 0.3,
        },
      };
      QRCode.toDataURL(val, opts, (err, url) => {
        if (err) throw err;
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    copyUrl(content) {
      /**
       * 复制内容到粘贴板
       * content : 需要复制的内容
       * message : 复制完后的提示，不传则默认提示"复制成功"
       */
      const aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message.success("复制成功");
    },

    // =================================man only start====================================
    //审核--驳回
    rejectClick() {
      this.rejectForm.rejectlineDialog = true;
    },
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons === "") {
          this.$message.error("驳回理由不能为空");
        } else {
          //contentAuditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
          rejectedDiseaseSymptoms({
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.rejectForm.rejectlineDialog = false;
              this.rejectForm.rejectReasons = ""; //置空驳回原因
              this.$message.success("驳回成功");
              this.hopStorage();
              this.actionType == 8
                ? this.$router.push(`/wikiManage/wiki`)
                : this.$router.push(`/wikiManage/symptom`);
            })
            .catch((err) => {
              this.$message.error(err.msg || "发布失败");
            });
        }
      } else {
        this.rejectForm.rejectlineDialog = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common/mixin.scss";
@import "@/styles/pages/articleBAK.scss";

.content {
  padding: 26px 25px 18px 26px;
}

.articleSymptom {
  // 表单Item样式
  .wrap .content-item p {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;
    span {
      color: #f62458;
      margin-right: 5px;
    }
  }
}
.article {
  .good-article {
    width: 112px !important;
    margin-left: 270px;
    cursor: pointer;
  }
  .auditInfo {
    .auditName {
      width: auto !important;
      height: auto !important;
      padding: 40px 0 30px 24px;
      font-family: PingFangSC-Medium;
      font-size: 28px;
      color: #262626;
    }

    .auditJob {
      margin-top: 10px;
      padding: 0px 0 30px 23px;
      font-family: PingFang-SC-Regular;
      font-size: 16px;
      color: #9a9a9a;
    }
  }

  .department-item {
    font-size: 14px;
    color: #2c3443;
    margin-top: 20px;
    position: relative;
    width: 50%;

    p {
      width: 107px;
      text-align: right;
      margin-right: 10px;
      flex-shrink: 0;

      span {
        color: #f62458;
        margin-right: 5px;
      }
    }
  }

  .tabs {
    border: 1px solid #0058ee !important;
    border-radius: 4px !important;
    color: #0058ee !important;
    background: url("~@/assets/choose.png") right bottom no-repeat;
    background-size: 18px;

    span {
      color: #0058ee !important;
    }

    .have {
      cursor: pointer;
    }

    :deep(.button.el-button.el-button--default) {
      padding-top: 10px;
    }
  }

  .dialog-input {
    width: 558px;
  }

  .color {
    margin-left: 24px;
  }

  .dislog-sub-title {
    color: #8b8c9a;
    font-size: 12px;
    margin-top: 14px;
  }

  .image {
    margin-top: 20px;
  }

  .qrCode {
    width: 182px;
    height: 182px;
    margin: 60px auto;
    margin-bottom: 0px;
  }

  .img-des {
    margin: 0 auto;
    width: 182px;

    text-align: center;
  }

  .item-video-wrap {
    border: 1px solid #c0c4cc;
  }

  :deep(.el-textarea__inner) {
    min-height: 130px !important;
    resize: none;
  }

  :deep(.el-form-item) {
    margin-bottom: 22px;
  }

  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  .freezeDom {
    margin-top: 30px;

    .freezeInp {
      max-height: 130px;
      max-width: 276px;
      // overflow: hidden;
      :deep(.el-input__count) {
        background: rgba(2, 1, 1, 0);
        bottom: -30px;
      }
    }

    .mar-top30 {
      margin-top: 30px;
    }
  }

  :deep(.el-button) {
    line-height: 10px;
  }

  .article_tit {
    :deep(.el-input__suffix) {
      left: 100% !important;
      right: auto !important;
    }
  }

  .check-box {
    @include singleline-ellipsis;
  }
}

.finish-buttons {
  width: 307px;
  height: 32px !important;
  margin-top: 62px;
  margin-left: 61px;
}

//关键词
.keyword-list {
  width: 645px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  :deep(.el-tag) {
    margin-top: 5px;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;

    .el-tag__close {
      color: #909399;

      &:hover {
        background-color: #f4f4f5;
      }
    }
  }

  .input-keyword {
    border: none;
    flex-shrink: 0;
    width: 315px !important;

    :deep(.el-input__inner) {
      border: none !important;
      line-height: 26px;
      height: 26px;
    }
  }
}

.writeDoc {
}

.article .wrap .writeDoc :deep(.el-input) {
  width: 645px !important;
}
// 文字过多，省略样式
.content-item > p {
  line-height: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
// 防止页面抖动
// :deep(.el-cascader .el-input .el-input--suffix){
//   transition: none !important;
// }
.finish-buttons,
.finish-btns {
  position: fixed;
  text-align: center;
  width: 86%;
  background-color: #ffffff;
  bottom: 0;
  z-index: 9;
  margin-left: 0 !important;
}
.alias {
  margin-left: 80px;
}
:deep(.content-item-label) {
  margin-right: 10px;
}
:deep(.el-input .el-input__count .el-input__count-inner) {
  margin-left: -41px;
}
</style>
